// keycloak.js
import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
    url: 'https://auth.dataplace.app',
    realm: 'dataplace',
    clientId: 'supriseg-painel-separacao'
});

export default keycloak;
